<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'INTERFACE|Ładowanie' | translate }}</h3>
    </div>
    <div class="dialog-body">
        <div class="loader-container">
            <div class="loader"></div>
        </div>
        <p *ngIf="error === 'TIMEOUT'">{{ 'INTERFACE|Ładowanie trwa dłużej niż zwykle' | translate : errorCtx }}</p>
        <p *ngIf="error === 'NO_ACCESS'">{{ 'INTERFACE|Brak dokumentu! Przekierowuję na aktualną listę... {timeLeft}' | translate : errorCtx}}</p>
        <p *ngIf="error === 'SYNC_ERROR'">{{ 'INTERFACE|Błąd ładowania. Daj nam chwilę, spróbujemy naprawić. {timeLeft}' | translate : errorCtx}}</p>
        <p *ngIf="generalError && error?.length && error !== 'TIMEOUT' && error !== 'NO_ACCESS' && error !== 'SYNC_ERROR'">{{ 'INTERFACE|Błąd ładowania dokumentu. Odśwież system lub skontaktuj się z dostawcą.' | translate : errorCtx}}</p>
    </div>
    <div class="dialog-footer" *ngIf="error?.length">
        <div class="flex-horizontal width-100">
            <button iccButton (click)="cancel()" appearance="outline" class="right" *ngIf="error === 'TIMEOUT' || error === 'NO_ACCESS' || error === 'SYNC_ERROR'">{{ 'INTERFACE|Przerwij ładowanie' | translate}}</button>
            <button iccButton (click)="refresh()" appearance="outline" class="right" *ngIf="generalError && error !== 'TIMEOUT' && error !== 'NO_ACCESS' && error !== 'SYNC_ERROR'">{{ 'INTERFACE|Odśwież system' | translate}}</button>
        </div>
    </div>
</div>